import { ConnectorGlyph } from '@/components/points/ConnectorGlyph';
import { ChargerStatusBadge, isChargerSelectable } from '@/components/points/ChargerStatusBadge';
import { connectorLabel } from '@/lib/connectorLabel';
import type { ConnectorOut } from '@/api/points';

interface Props {
  connector: ConnectorOut;
  onClick: () => void;
  /** "Conector A/B" em vez de número — capability `connector_letters` do ponto. */
  letterLabel?: boolean;
}

/** Linha de conector — estação de 1 carregador só, sem precisar agrupar
 * (mapfirst-a.jsx · `ConnectorRow`). Vários destes lado a lado, num flex row. */
export function ConnectorRow({ connector, onClick, letterLabel = false }: Props) {
  const selectable = isChargerSelectable(connector.state);
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!selectable}
      className="flex flex-1 items-center gap-2.5 rounded-2xl bg-bow-cream-2/50 p-3 text-left disabled:cursor-not-allowed disabled:opacity-70"
    >
      <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-white text-bow-royal shadow-sm">
        <ConnectorGlyph type={connector.type} size={17} />
      </span>
      <div className="min-w-0">
        <div className="text-[12.5px] font-semibold tracking-tight text-bow-royal">
          Conector {connectorLabel(connector.connector_number, letterLabel)}
        </div>
        <div className="mt-1">
          <ChargerStatusBadge state={connector.state} />
        </div>
      </div>
    </button>
  );
}
